module.exports = __webpack_public_path__ + "img/17_53.478661da.png";